import styled from 'styled-components';

const Container = styled.div`
	min-height: ${props =>
		(props.dependentIsActive == true &&
			props.formOfPayment === 'Cartão' &&
			props.count >= 2) ||
		(props.formOfPayment === 'Cartão' && props.count >= 3)
			? 'auto'
			: '100vh'};

	background: ${({ theme }) => theme.backgroundContainer};
	background-size: 22vh, 20vh;

	@media (max-height: 769px) {
		min-height: ${props =>
			(props.dependentIsActive == true &&
				props.count >= 1 &&
				props.showForm === true) ||
			(props.count > 1 && props.showForm === true) ||
			props.formOfPayment ||
			(props.isEdit && props.position === 0)
				? 'auto'
				: '100vh'};
	}

	@media (max-width: 992px) {
		background: none;
	}
`;

export default Container;
